import React from 'react';
import { Form, Button, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import PropTypes from 'prop-types';
import { UPLOAD_FILE } from 'gql/files';
// import { PROPTYPES_SUBFOLDER } from 'constants/form';

const downloadUrl = process.env.REACT_APP_DOWNLOAD_URL;
const uploadSizeLimit = process.env.REACT_APP_UPLOAD_SIZE_LIMIT;
// const beforeUpload = (file) => {};

const FormUpload = ({
  name,
  label,
  maxCount,
  defaultFileList,
  projectId,
  subFolder,
  multiple,
  disabled,
  ...rest
}) => {
  const [uploadFile] = useMutation(UPLOAD_FILE);

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    let fileList = [...e.fileList];
    fileList = fileList.slice(maxCount * -1);
    return e && fileList;
  };
  return (
    <Form.Item
      {...rest}
      name={name}
      label={label}
      valuePropName="fileList"
      getValueFromEvent={normFile}
    >
      <Upload
        defaultFileList={defaultFileList}
        multiple={multiple}
        // beforeUpload={beforeUpload}
        customRequest={async ({ file, onError, onSuccess }) => {
          const isBelowLimit = file.size / 1024 / 1024 < uploadSizeLimit;
          if (!isBelowLimit) {
            message.error(`File must smaller than ${uploadSizeLimit}MB!`);
            return onError(`File must smaller than ${uploadSizeLimit}MB!`);
          }
          try {
            const {
              data: { uploadFile: response },
            } = await uploadFile({
              variables: { input: { upload: file, projectId, subFolder } },
            });
            file.url = `${downloadUrl}${response.id}`;
            file.id = response.id;
            onSuccess(response, file);
            message.success('upload successfully');
          } catch (error) {
            console.log({ error });
            onError(error);
            message.error('upload failed');
          }
        }}
      >
        <Button icon={<UploadOutlined />} disabled={disabled}>
          Select File
        </Button>
      </Upload>
    </Form.Item>
  );
};

FormUpload.defaultProps = {
  defaultFileList: [],
  maxCount: 10,
  extra: '',
  projectId: '',
  multiple: false,
  disabled: false,
};

FormUpload.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  extra: PropTypes.string.isRequired,
  maxCount: PropTypes.number.isRequired,
  defaultFileList: PropTypes.array.isRequired,
  projectId: PropTypes.string.isRequired,
  subFolder: PropTypes.string,
  multiple: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default FormUpload;
